import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { notificationsEndpoints } from '@/modules/notifications/constants';
import { notificationsQueryKeys } from '@/modules/notifications/queries/queryKeys';

import { markReadInCache } from './markReadInCache';

export const useReadAllNotificationsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const { data } = await fetchClient.PUT(
        notificationsEndpoints.readAllNotifications,
      );
      return data;
    },
    onMutate: () => markReadInCache(queryClient, () => true),
    onError: (_error, _variables, rollback) => rollback?.(),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: notificationsQueryKeys.list(),
      }),
  });
};
